export type Errors = string | null | undefined | string[];

export const getErrorMessage = (errors: Errors): string | null => {
    if (!errors) return null;
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors[0];
    return null;
};
